<template>
	<div class="con">
		<div class="pay-title">
			<div>住院缴费记录</div>
			<div>
				<div @click="showPopup">{{currentDate.getFullYear()}}</div>
				<van-popup v-model="show" position="top" custom-style="height: 20%;">
					<van-datetime-picker :max-date="maxDate" type="year" v-model="currentDate" @cancel="onClose()" @confirm="confirmFn(currentDate)" />
				</van-popup>
			</div>
		</div>
		<div class="list" v-if="list.length > 0">
			<div v-for="(item, index) in list">
				<div class="list-con">
					<div class="list-con-top" @click="showBtn(index)">
						<div>
							<div class="title">{{item.KSMC}}</div>
							<div class="serial-number">住院序号：{{item.ZYH}}</div>
							<div class="time-disp">
								<!-- <van-icon name="underway-o" color="#27BEC4" /> -->
								<div class="time-text">入院日期：{{item.FYRQ}}</div>
							</div>
							<div class="time-disp">
								<!-- <van-icon name="underway-o" color="#27BEC4" /> -->
								<div class="time-text">结算时间：{{item.JSRQ}}</div>
							</div>
						</div>
						<div class="price">
							<div><span>￥</span>{{item.deposiNum}}</div>
							<van-icon name="arrow" color="#ccc" v-if="!item.showState" />
							<van-icon name="arrow-down" color="#ccc" v-else />
						</div>
					</div>
					<div class="deposit-list">
						<div v-for="(dep, depIndex) in item.deposit[0]" class="deposit">
							<div v-if="dep.jscs > 0">已使用押金：￥{{dep.jkje}}</div>
							<div v-else>未使用押金：￥{{dep.jkje}}</div>
						</div>
					</div>
				</div>
				<div class="show-box" v-show="item.showState">
					<div v-for="(d, i) in item.d" @click="showBtnClass(index, i)">
						<div class="show-disp">
							<div style="font-size: 14px;">{{d.SFMC}}</div>
							<div style="display: flex;">
								<div class="price"><span>￥</span>{{d.detailTotal}}</div>
								<van-icon name="arrow" color="#ccc" v-if="!d.showStateClass" />
								<van-icon name="arrow-down" color="#ccc" v-else />
							</div>
						</div>
						<div class="show-disp" v-for="(data, deIndex) in d.detail" v-show="d.showStateClass">
							<div class="medicines">
								<div>{{data.FYMC}}</div>
								<div>医生：{{data.YGXM}}</div>
								<div class="time-disp">
									<van-icon name="underway-o" color="#27BEC4" />
									<div class="time-text">{{data.FYRQ}}</div>
								</div>
							</div>
							<div class="show-disp-right">
								<div class="box-num">x{{data.FYSL}}</div>
								<div class="box-unit-price"><span>￥</span>{{data.ZJJE}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无缴费记录~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inpatientDeposit',
		data() {
			return {
				msg: '缴费记录',
				currentDate: new Date(),
				maxDate: new Date(),
				list: [],
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				noImgShow: false,
				show: false,
			}
		},
		methods: {
			showPopup() {
				this.show = true;
			},

			onClose() {
				this.show = false;
			},
			confirmFn(e) {
				this.currentDate = e;
				this.show = false;
				this.GetDepositList()
			},
			//缴费
			GetDepositList() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/inpatient/getInFy?brid=' + this.cardUserInfo.bahm + '&sfzh=' + this.cardUserInfo.sfzh + '&name=' +
					this.cardUserInfo.name + '&type=2' + '&year=' + this.currentDate
					.getFullYear(), null).then(data => {
					console.log(data)
					this.$store.commit('Load', false)
					if (data.code == 0) {
						let dataList = data.msg;
						let tbkkListMap = data.tbkkList;
						if (data.msg.length != 0) {
							this.noImgShow = false;

							let newArr = JSON.parse(JSON.stringify(dataList));
							let newClassified = JSON.parse(JSON.stringify(dataList));

							//根据住院号ZHY分总
							for (let i = 0; i < newArr.length; i++) {
								newArr[i].showState = false;
								let total = 0;
								for (let j = i + 1; j < newArr.length;) {

									if (newArr[i].ZYH == newArr[j].ZYH) {
										total += Number(newArr[j].ZJJE);
										newArr.splice(j, 1)
									} else {
										j++;

									}
								}
								total += Number(newArr[i].ZJJE);
								newArr[i].total = total.toFixed(2);
								newArr[i].deposiNum = total.toFixed(2);
								newArr[i].deposiArr = []
							}
							//住院号一样，分药类型SFMC
							for (let k = 0; k < newArr.length; k++) {
								for (let i = 0; i < newClassified.length; i++) {
									newClassified[i].showStateClass = false;
									if (newArr[k].ZYH == newClassified[i].ZYH) {
										for (let j = i + 1; j < newClassified.length;) {
											if (newClassified[i].SFMC == newClassified[j].SFMC) {
												newClassified.splice(j, 1)
											} else {
												j++;
											}
										}
									}
								}
							}

							for (let k = 0; k < newClassified.length; k++) {
								let s = [];
								let n = 0;
								for (let j = 0; j < dataList.length; j++) {
									if (newClassified[k].SFMC == dataList[j].SFMC) {
										n += Number(dataList[j].ZJJE);
										s.push(dataList[j])
									}
								}
								newClassified[k].detail = s;
								newClassified[k].detailTotal = n.toFixed(2);
							}

							for (let k = 0; k < newArr.length; k++) {
								newArr[k].d = newClassified;

							}

							newArr.map((value, index) => {
								let deposit = [];
								Object.keys(tbkkListMap).forEach(key => {
									tbkkListMap[key].map((v) => {
										v.flag = false;
									})
									if (value.ZYH == key) {
										deposit.push(tbkkListMap[key])
									}
								})
								value.deposit = deposit
							})

							console.log(newArr)
							this.list = newArr;

						} else {
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}

				}).catch(err => {
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},

			//显示隐藏详情
			showBtn(e) {
				let listData = this.list;

				listData[e].showState = !listData[e].showState;
				this.list = listData;
			},
			showBtnClass(index, i) {
				let listData = this.list;

				listData[index].d[i].showStateClass = !listData[index].d[i].showStateClass;
				this.list = listData;
			},
		},
		mounted() {
			console.log(JSON.parse(localStorage.getItem('cardUserInfo')))
			this.GetDepositList()
		},
		created() {},
	}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
	}

	.head {
		padding: 20px 10px;
		background: linear-gradient(to left, #fff, #27BEC4);
		color: #fff;
		font-size: 15px;
	}

	.pay-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}

	.list {
		flex: 1;
		overflow-y: scroll;
	}

	.list-con {
		padding: 20px;
		margin-bottom: 5px;
		font-size: 14px;
		border-bottom: 1px solid #ccc;
		background: #fff;
	}

	.list-info {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.title{
		color: #000000;
		font-weight: 700;
		font-size: 18px;
	}
	.text {
		font-size: 17px;
		font-weight: 500;
		color: #000;
	}

	.price {
		font-size: 18px;
		color: #FF0000;
	}

	.list-time {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}


	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}


	.list {
		flex: 1;
		overflow-y: auto;
	}

	.list-con-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.time-disp {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}


	.price {
		display: flex;
		align-items: center;
		color: #FF0000;
		font-size: 18px;
		font-weight: 700;
	}

	.price span {
		font-weight: 500;
		font-size: 12px;
	}

	.total {
		display: flex;
		font-size: 15px;
	}

	.total div {
		padding: 20px 0;
		width: 50%;
		text-align: center;
	}

	.combined {
		background-color: #fff;
	}

	.combined span {
		color: #FF0000;
		font-size: 18px;
	}

	.pay-btn {
		background-color: #27BEC4;
		color: #fff;
	}


	.show-box {
		padding: 10px;
		margin: 0 auto;
		width: 85%;
		background-color: #fff;
	}

	.show-disp {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
	}

	.medicines {
		width: 75%;
		color: #666;
		font-size: 14px;
	}

	.box-unit-price {
		font-size: 14px;
		color: #FF0000;
		font-weight: 700;
	}

	.box-unit-price span {
		font-weight: 500;
		font-size: 12px;
	}

	.box-num {
		text-align: end;
	}
	.deposit {
		display: flex;
		align-items: center;
		margin: 10px 0;
		font-size: 14px;
		color: #666;
	}
</style>
